import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const JobDetailsContext = createContext();

// Create a custom hook to use the context
export const useJobDetailContext = () => {
    return useContext(JobDetailsContext);
};

// Create a provider component
export const JobDetailsContextProvider = ({ children }) => {

    const [jobStatus, setJobStatus] = useState(false)
    const [jobName, setJobName] = useState('')
    const [jobRefId, setjobRefId] = useState('')
    const [jobId, setJobId] = useState('')
    const [autoEmailEnable, setAutoEmailEnable] = useState('')

    //onload

    useEffect(()=>{
        if(sessionStorage.getItem("jobRef")){
            setjobRefId(sessionStorage.getItem("jobRef"))
        }
        if(sessionStorage.getItem("jobName")){
            setJobName(sessionStorage.getItem("jobName"))
        }
        if(sessionStorage.getItem("jobStatus")){
            setJobStatus(JSON.parse(sessionStorage.getItem("jobStatus")))
        }
        if(sessionStorage.getItem("jobId")){
            setJobId(JSON.parse(sessionStorage.getItem("jobId")))
        }
        if(sessionStorage.getItem("autoEmailEnable")){
            setAutoEmailEnable(JSON.parse(sessionStorage.getItem("autoEmailEnable")))
        }
    },[])

    //set job details  

    const jobDetails = (jobStatus, jobName, jobRefId, jobId, autoEmailEnable) => {
        setJobStatus(jobStatus)
        setJobName(jobName)
        setjobRefId(jobRefId)
        setJobId(jobId)
        setAutoEmailEnable(autoEmailEnable)
    }

    return (
        <JobDetailsContext.Provider value={{ jobDetails, jobStatus, jobName, jobRefId, jobId, autoEmailEnable }}>
            {children}
        </JobDetailsContext.Provider>
    );
};